import React from 'react'
import Link from 'next/link'
import { useRouter } from 'next/router'

interface Props {
  href?: string
  external?: boolean
  newPage?: boolean
  prefetch?: boolean
  title?: string
  download?: boolean
  focusable?: boolean
  ariaLabel?: string
  role?: string
  onClick?: (event: React.MouseEvent<HTMLButtonElement | HTMLAnchorElement>) => void
  onFocus?: (event: React.FocusEvent<HTMLButtonElement | HTMLAnchorElement>) => void
  handleTracking?: (ty?: string, c?: string, t?: string, cta?: string) => void
  locale?: string | false
  next?: boolean
  style?: React.CSSProperties
  className?: string
  children?: any
}

const WLink = (props: Props) => {
  const {
    href = null,
    title = undefined,
    download = undefined,
    focusable = true,
    ariaLabel = undefined,
    role = undefined,
    newPage = false,
    prefetch = true,
    onClick = undefined,
    onFocus = undefined,
    locale = false,
    next = true,
    style = undefined,
    className = '',
    children = null,
  } = props

  const router = useRouter()

  return !next ? (
    <a
      href={href || '/'}
      className={className}
      style={style}
      target={newPage ? '_blank' : undefined}
      rel={newPage ? 'noopener noreferrer' : undefined}
      onClick={onClick}
      onFocus={onFocus}
      title={title}
      download={download || undefined}
      aria-label={ariaLabel}
      role={role}
      tabIndex={focusable ? undefined : -1}
    >
      {children}
    </a>
  ) : (
    <Link
      href={href || '/'}
      className={className}
      style={style}
      target={newPage ? '_blank' : undefined}
      rel={newPage ? 'noopener noreferrer' : undefined}
      onClick={onClick}
      onFocus={onFocus}
      title={title}
      download={download || undefined}
      aria-label={ariaLabel}
      role={role}
      tabIndex={focusable ? undefined : -1}
      locale={locale || router.locale}
      {...(!prefetch || router.isPreview || process.env.NEXT_PUBLIC_DISABLE_LINK_PREFETCH === 'true'
        ? { prefetch: false }
        : {})}
    >
      {children}
    </Link>
  )
}

export default WLink
